<template>
  <BaseModal
    small
    verticalAlignCenter
    @close="emit('close')"
    testId="wavy-onboarding-confirmation"
  >
    <Flex
      direction="column"
      :gap="2"
    >
      <BaseStatusIcon state="success" />
      <Flex
        direction="column"
        :gap="0.5"
        justify="center"
        align="center"
      >
        <BaseHeading size="l">
          {{ $t('wavy_onboarding.confirmation.heading') }}
        </BaseHeading>
        <BaseText v-test="'wavy-onboarding-confirmation-message'">
          {{ $t('wavy_onboarding.confirmation.message', { ...brandName(), company: company.name }) }}
        </BaseText>
      </Flex>
      <Flex
        direction="column"
        :gap="0.5"
      >
        <BaseAlert
          :text="$t('wavy_onboarding.confirmation.info_trial', { date: filters.date(company.trialEndAt, { format: 'long', addYear: true }) })"
          color="success"
          v-test="'wavy-onboarding-confirmation-info-trial'"
        />
        <BaseAlert
          color="info"
          :text="$t('wavy_onboarding.confirmation.info_2')"
        />
      </Flex>
      <BaseButton
        @click="emit('close')"
        v-test="'wavy-onboarding-confirmation-submit'"
      >
        {{ $t('wavy_onboarding.confirmation.button_text', brandName()) }}
      </BaseButton>
    </Flex>
  </BaseModal>
</template>

<script
  setup
  lang="ts"
>
import eventBus from '@/event-bus';
import filters from '@/filters';
import { brandName } from '@/helpers/brand-name';
import { useCompanyStore } from '@/stores/company';

const emit = defineEmits(['close']);

const { company } = useCompanyStore();

onUnmounted(() => {
  eventBus.$emit('show-wavy-tasks');
});
</script>
